<template>
  <div>
    <Content :button-create-show="true">
      <template #body>
        <div class="users-disclaimer">
          <p>
            Аккаунты полевых сотрудников (SR/SV) обезличены и привязаны к
            номерам маршрутов, в случае смены сотрудника на маршруте, аккаунт
            привязанный к этому маршруту передается новому сотруднику (для
            передачи аккаунта необходимо сбросить пароль).
          </p>
          <p>
            ЗАПРЕЩЕНО использовать ФИО и email сотрудников при создании любых
            аккаунтов (запрет на любые персональные данные).
          </p>
        </div>
        <Table
          ref="table"
          v-loading="loading"
          :columns="columns"
          :options="columnsOptions"
          :method-fetch-data="fetchData"
          :method-delete-row="deleteRow"
        >
          <template v-slot:controls="{ row }">
            <div class="button-group-vertical">
              <router-link :to="`edit/${row.id}`">
                <el-button icon="el-icon-edit" size="mini"
                  >Редактировать</el-button
                >
              </router-link>
              <el-popconfirm
                title="Задать временный пароль пользователя?"
                confirm-button-text="Сгенерировать временный пароль"
                cancel-button-text="Нет"
                @confirm="setPassword(row.id)"
              >
                <el-button slot="reference" icon="el-icon-edit" size="mini"
                  >Задать пароль</el-button
                >
              </el-popconfirm>
              <router-link :to="`edit/${row.id}/regions/append/`">
                <el-button icon="el-icon-edit" size="mini">
                  Добавить регионы
                </el-button>
              </router-link>
              <router-link :to="`edit/${row.id}/regions/remove/`">
                <el-button icon="el-icon-delete" size="mini">
                  Удалить регионы
                </el-button>
              </router-link>
              <router-link :to="`vrio/${row.id}/list`">
                <el-button icon="el-icon-view" size="mini">
                  Заместители
                </el-button>
              </router-link>
              <el-popconfirm
                v-if="row.is_perm_blocked"
                :title="`Вы уверены, что хотите разблокировать пользователя ${row.name}?`"
                confirm-button-text="Подтвердить разблокировку"
                cancel-button-text="Отмена"
                @confirm="unblockUser(row.id)"
              >
                <el-button
                  slot="reference"
                  icon="el-icon-warning-outline"
                  size="mini"
                  >Разблокировать</el-button
                >
              </el-popconfirm>
            </div>
          </template>
        </Table>
      </template>
    </Content>
    <el-dialog
      :visible.sync="dialogVisible"
      width="400px"
      title="Временный пароль"
      @close="$emit('close')"
    >
      <CopyInput :text="text" />
      <p style="word-break: break-word">
        Скопируйте временный пароль. Он отображается один раз и станет
        недоступен после закрытия окна.
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >Закрыть</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";
import { getRegions } from "@/api/regions";
import {
  getUsers,
  deleteUser as deleteRow,
  unblockUser as unblockUserApi,
} from "@/api/users";
import { enumUserRoles } from "@/utils/filters";
import { mapGetters } from "vuex";
import { setUserPassword } from "@/api/users";
import CopyInput from "@/components/CopyInput.vue";

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 300,
  },
  {
    prop: "username",
    label: "@username",
  },
  {
    prop: "name",
    label: "ФИО",
  },
  {
    prop: "roles",
    label: "Роль",
    type: "enum",
    alias: "role_type",
  },
  {
    prop: "block_status",
    label: "Статус блокировки",
    formatter: (row) => {
      if (row.is_perm_blocked) {
        return "Перманентная блокировка";
      }
      if (row.is_temp_blocked) {
        return "Временная блокировка";
      }
      return "Разблокирован";
    },
  },
];

export default {
  components: {
    Content,
    Table,
    CopyInput,
  },
  computed: {
    ...mapGetters(["regions", "roles", "regionsName"]),
  },
  data() {
    return {
      columnsOptions: {
        sortable: "custom",
        controls: {
          width: 190,
        },
        id: "id",
        editable: true,
      },
      columns: columns,
      loading: false,
      dialogVisible: false,
      text: "",
    };
  },
  async created() {
    this.columnsOptions = await this.getColumnsOptions();
  },
  methods: {
    async unblockUser(userId) {
      try {
        this.loading = true;
        await unblockUserApi(userId);
        this.$message({
          type: "success",
          message: "Аккаунт разблокирован!",
        });
        this.$refs.table.fetchData();
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    filterByRole(params) {
      // добавляем фильтрацию по ролям для adminregion
      if (this.roles?.length && this.roles[0] === "adminregion") {
        params.roles = [
          "sales",
          "supervisor",
          "ldfd",
          "traderegion",
          "trademacro",
          "merchmacro",
          "tradecentral",
          "lca",
          "contractor",
        ];
      }
      return params;
    },
    filterByRegion(params) {
      if (this.regions?.length) {
        params.regions = this.regions;

        // добавляем пользователей без регионов
        params.no_regions = true;
      }
      return params;
    },
    async fetchData(params) {
      params = this.filterByRole(params);
      if (params["region.name"]) {
        delete params.regions;
        delete params.no_regions;
      } else {
        params = this.filterByRegion(params);
      }

      const data = await getUsers(params);

      return data.users;
    },
    deleteRow,
    async getColumnsOptions() {
      const regions = this.regionsName
        ? Object.entries(this.regionsName).map(([id, name]) => ({
            code: name,
            label: name,
          }))
        : [];
      const roleFilterValues = [
        ...enumUserRoles.map((role) => ({
          code: role.id,
          label: role.name,
        })),
        {
          code: "author",
          label: "Автор",
        },
      ];

      return {
        ...this.columnsOptions,
        search_list: [
          {
            strong: true,
            name: "username",
            label: "Поиск по @username",
          },
          {
            strong: true,
            name: "name",
            label: "Поиск по ФИО",
          },
          {
            strong: true,
            name: "region.name",
            label: "Фильтр по региону",
            values: regions,
          },
          {
            strong: true,
            name: "roles",
            label: "Фильтр по роли",
            values: roleFilterValues,
          },
        ],
      };
    },
    async setPassword(id) {
      this.loading = true;
      try {
        const response = await setUserPassword(id);

        // показываем модальное окно
        this.dialogVisible = true;
        this.text = response.temp_password;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.users-disclaimer {
  margin-bottom: 16px;
  padding: 12px 16px;
  background-color: #fff7e6;
  border: 1px solid #f5d8a8;
  border-radius: 4px;
}

.users-disclaimer p {
  margin: 0;
  line-height: 1.5;
}

.users-disclaimer p + p {
  margin-top: 8px;
}
</style>
